import { Heart } from 'lucide-react';

export const ReturnAffectifChallenges = () => (
<div className="bg-gradient-to-br from-gray-900/80 to-black/80 p-8 rounded-2xl border-2 border-red-600/40 backdrop-blur-sm">
                <h4 className="text-2xl font-bold text-red-500 mb-6">Vous Souffrez d'une Rupture Amoureuse ?</h4>
                <ul className="space-y-4 text-gray-200">
                  <li className="flex items-start">
                    <Heart className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" />
                    <span><strong>Votre ex ne vous parle plus</strong> et refuse tout contact malgré vos tentatives ?</span>
                  </li>
                  <li className="flex items-start">
                    <Heart className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" />
                    <span><strong>Votre ex est avec quelqu'un d'autre</strong> et semble heureux dans sa nouvelle relation ?</span>
                  </li>
                  <li className="flex items-start">
                    <Heart className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" />
                    <span><strong>Vous avez tout essayé</strong> mais rien ne fonctionne pour récupérer votre amour perdu ?</span>
                  </li>
                  <li className="flex items-start">
                    <Heart className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" />
                    <span><strong>La séparation date de plusieurs mois</strong> voire plusieurs années et vous pensez que c'est trop tard ?</span>
                  </li>
                  <li className="flex items-start">
                    <Heart className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" />
                    <span><strong>Votre ex est sous l'emprise</strong> d'une tierce personne qui utilise la sorcellerie contre vous ?</span>
                  </li>
                </ul>
              </div>
);
